import {
  CREATE_QR_CODE_FAILURE,
  CREATE_QR_CODE_REQUEST,
  CREATE_QR_CODE_SUCCESS,
  GET_QR_CODES_FAILURE,
  GET_QR_CODES_REQUEST,
  GET_QR_CODES_SUCCESS
} from "./actionTypes";

const initialState = {
  data: [],
  tableLoading: false,
  isButtonLoading: false,
  isError: false,
};

const qrCodesReducer = (
  state = initialState,
  { type, payload },
) => {
  switch (type) {
    case GET_QR_CODES_REQUEST:
      return {
        ...state,
        tableLoading: true,
      };
    case GET_QR_CODES_SUCCESS:
      return {
        ...state,
        data: payload,
        tableLoading: false,
      };
    case GET_QR_CODES_FAILURE:
      return { ...state, tableLoading: false };
    case CREATE_QR_CODE_SUCCESS:
      return { ...state, isButtonLoading: false, isError: false };
    case CREATE_QR_CODE_FAILURE:
      return { ...state, isButtonLoading: false, isError: true };
    case CREATE_QR_CODE_REQUEST:
      return { ...state, isButtonLoading: true };
    default:
      return state;
  }
};

export default qrCodesReducer;
